import React from 'react';

function TableHead({ name, width, rightAlign, isWrap = false }) {
  const style = { width: `${width}%` };
  const lines = typeof name === 'string' && name.includes('\n') ? name.split('\n') : null;
  const label = lines
    ? lines.map((line, i) => (
        <React.Fragment key={i}>
          {line}
          {i < lines.length - 1 && <br />}
        </React.Fragment>
      ))
    : name;

  return (
    <div
      className={`flex ${rightAlign ? 'justify-end' : 'justify-start'} px-3 ${isWrap ? 'whitespace-nowrap' : ''}`} // If design break, remove margin
      style={style}>
      {label}
    </div>
  );
}

export default TableHead;
